import React, { useState, useEffect, useRef } from 'react';
import './AdminPanel.css';
import { useTranslation } from 'react-i18next';

// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru//api';

const AdminPanel = ({ onBack, cartItems, user, onUpdateAdmins, adminIps }) => {
  const { t } = useTranslation();
  const [services, setServices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedService, setSelectedService] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [editForm, setEditForm] = useState({ name: '', price: '', description: '', image_url: '' });
  const [addForm, setAddForm] = useState({ subcategory_id: '', name: '', price: '', description: '', image_url: '' });
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [selectedSubcategoryId, setSelectedSubcategoryId] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [activeMainTab, setActiveMainTab] = useState('services');
  
  // Модалки для категорий и подкатегорий
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showAddSubcategoryModal, setShowAddSubcategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newSubcategoryName, setNewSubcategoryName] = useState('');
  const [selectedParentCategoryId, setSelectedParentCategoryId] = useState('');
  
  const [allowedIps, setAllowedIps] = useState([]);
  const [showAddIpModal, setShowAddIpModal] = useState(false);
  const [newIp, setNewIp] = useState('');
  const [stats, setStats] = useState({ total_services: 0, total_categories: 0, total_subcategories: 0, total_admin_ips: 0, total_admins: 0, total_doctors: 0, total_news: 0 });
  
  // ВРАЧИ
  const [doctors, setDoctors] = useState([]);
  const [showAddDoctorModal, setShowAddDoctorModal] = useState(false);
  const [editingDoctor, setEditingDoctor] = useState(null);
  const [doctorForm, setDoctorForm] = useState({ name: '', specialization: '', description: '', image_url: '' });
  const [selectedDoctorServices, setSelectedDoctorServices] = useState(null);
  const [doctorServices, setDoctorServices] = useState([]);
  const [showDoctorServicesModal, setShowDoctorServicesModal] = useState(false);
  const [editingDoctorService, setEditingDoctorService] = useState(null);
  const [doctorServiceForm, setDoctorServiceForm] = useState({ name: '', price: '', description: '' });
  
  // НОВОСТИ
  const [news, setNews] = useState([]);
  const [showAddNewsModal, setShowAddNewsModal] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [newsForm, setNewsForm] = useState({ 
    title: '', 
    content: '', 
    description: '', 
    image_url: '', 
    video_url: '', 
    video_type: 'youtube',
    category: 'news',
    is_active: 1 
  });
  const [newsSearchTerm, setNewsSearchTerm] = useState('');
  const [uploadingNewsPhoto, setUploadingNewsPhoto] = useState(false);
  
  const fileInputRef = useRef(null);
  const serviceFileInputRef = useRef(null);
  const newsFileInputRef = useRef(null);

  // ============= ЗАГРУЗКА ДАННЫХ =============
  const fetchServices = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/services`);
      const data = await response.json();
      setServices(data);
    } catch (error) {
      console.error('Ошибка загрузки услуг:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_URL}/categories`);
      const data = await response.json();
      setCategories(data);
      console.log('✅ Категории загружены:', data);
    } catch (error) {
      console.error('Ошибка загрузки категорий:', error);
    }
  };

  const fetchSubcategories = async () => {
    try {
      const response = await fetch(`${API_URL}/subcategories`);
      const data = await response.json();
      setSubcategories(data);
      console.log('✅ Подкатегории загружены:', data);
    } catch (error) {
      console.error('Ошибка загрузки подкатегорий:', error);
    }
  };

  const fetchAdminIps = async () => {
    try {
      const response = await fetch(`${API_URL}/admin-ips`);
      const data = await response.json();
      setAllowedIps(data);
      if (onUpdateAdmins) onUpdateAdmins(data);
    } catch (error) {
      console.error('Ошибка загрузки IP:', error);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch(`${API_URL}/stats`);
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Ошибка загрузки статистики:', error);
    }
  };

  const fetchDoctors = async () => {
    try {
      const response = await fetch(`${API_URL}/doctors`);
      const data = await response.json();
      setDoctors(data);
    } catch (error) {
      console.error('Ошибка загрузки врачей:', error);
    }
  };

  const fetchDoctorServices = async (doctorId) => {
    try {
      const response = await fetch(`${API_URL}/doctor-services?doctor_id=${doctorId}`);
      const data = await response.json();
      setDoctorServices(data);
    } catch (error) {
      console.error('Ошибка загрузки услуг врача:', error);
    }
  };

  const fetchNews = async () => {
    try {
      const response = await fetch(`${API_URL}/news`);
      const data = await response.json();
      setNews(data);
    } catch (error) {
      console.error('Ошибка загрузки новостей:', error);
    }
  };

  // Загружаем все данные при входе
  useEffect(() => {
    if (isAuthenticated) {
      fetchServices();
      fetchCategories();
      fetchSubcategories();
      fetchAdminIps();
      fetchStats();
      fetchDoctors();
      fetchNews();
    }
  }, [isAuthenticated]);

  // ============= ФУНКЦИИ ДЛЯ КАТЕГОРИЙ =============
  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      alert('❌ Введите название категории');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/categories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newCategoryName, sort_order: categories.length + 1 })
      });
      
      if (response.ok) {
        await fetchCategories();
        await fetchStats();
        setShowAddCategoryModal(false);
        setNewCategoryName('');
        alert('✅ Категория успешно добавлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления категории:', error);
      alert('❌ Ошибка при добавлении категории');
    } finally {
      setIsLoading(false);
    }
  };

  // ============= ФУНКЦИИ ДЛЯ ПОДКАТЕГОРИЙ =============
  const handleAddSubcategory = async () => {
    if (!selectedParentCategoryId) {
      alert('❌ Выберите категорию');
      return;
    }
    if (!newSubcategoryName.trim()) {
      alert('❌ Введите название подкатегории');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/subcategories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          category_id: parseInt(selectedParentCategoryId), 
          name: newSubcategoryName, 
          sort_order: subcategories.filter(s => s.category_id === parseInt(selectedParentCategoryId)).length + 1
        })
      });
      
      if (response.ok) {
        await fetchSubcategories();
        await fetchStats();
        setShowAddSubcategoryModal(false);
        setNewSubcategoryName('');
        setSelectedParentCategoryId('');
        alert('✅ Подкатегория успешно добавлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления подкатегории:', error);
      alert('❌ Ошибка при добавлении подкатегории');
    } finally {
      setIsLoading(false);
    }
  };

  // Получить подкатегории для выбранной категории
  const getFilteredSubcategories = () => {
    if (!selectedCategoryId || subcategories.length === 0) return [];
    return subcategories.filter(sub => sub.category_id === parseInt(selectedCategoryId));
  };

  // Получить название категории по ID подкатегории
  const getCategoryName = (subcategoryId) => {
    const sub = subcategories.find(s => s.id === subcategoryId);
    if (!sub) return '—';
    const cat = categories.find(c => c.id === sub.category_id);
    return cat ? cat.name : '—';
  };

  // Получить название подкатегории по ID
  const getSubcategoryName = (subcategoryId) => {
    const sub = subcategories.find(s => s.id === subcategoryId);
    return sub ? sub.name : '—';
  };

  // ПРАВИЛЬНАЯ ФИЛЬТРАЦИЯ УСЛУГ
  const filteredServices = services.filter(service => {
    // Поиск по названию и цене
    const matchesSearch = searchTerm === '' || 
      service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.price.toString().includes(searchTerm);
    
    // Фильтр по подкатегории
    if (selectedSubcategoryId) {
      return matchesSearch && service.subcategory_id === parseInt(selectedSubcategoryId);
    }
    
    // Фильтр по категории - проверяем через subcategory_id
    if (selectedCategoryId) {
      const subIds = subcategories
        .filter(sub => sub.category_id === parseInt(selectedCategoryId))
        .map(sub => sub.id);
      return matchesSearch && subIds.includes(service.subcategory_id);
    }
    
    return matchesSearch;
  });

  const filteredNews = news.filter(item => 
    item.title.toLowerCase().includes(newsSearchTerm.toLowerCase()) ||
    item.description?.toLowerCase().includes(newsSearchTerm.toLowerCase())
  );

  // ============= ФУНКЦИИ ДЛЯ УСЛУГ =============
  const handleServicePhotoUpload = async (event, isEdit = false) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('❌ Поддерживаются только форматы: JPG, PNG, GIF, WEBP');
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      alert('❌ Размер фото не должен превышать 5MB');
      return;
    }
    
    setUploadingPhoto(true);
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (isEdit) {
          setEditForm({ ...editForm, image_url: reader.result });
        } else {
          setAddForm({ ...addForm, image_url: reader.result });
        }
        setUploadingPhoto(false);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Ошибка загрузки фото:', error);
      alert('❌ Ошибка при загрузке фото');
      setUploadingPhoto(false);
    }
  };

  const handleRemoveServicePhoto = (isEdit = false) => {
    if (isEdit) {
      setEditForm({ ...editForm, image_url: '' });
    } else {
      setAddForm({ ...addForm, image_url: '' });
    }
  };

  const handleEditClick = (service) => {
    setSelectedService(service);
    setEditForm({
      name: service.name,
      price: service.price,
      description: service.description || '',
      image_url: service.image_url || ''
    });
    setIsEditing(true);
  };

  const handleSaveChanges = async () => {
    if (!selectedService) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/services/${selectedService.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: editForm.name,
          price: editForm.price,
          description: editForm.description,
          image_url: editForm.image_url,
          admin_id: currentAdmin?.id || 1
        })
      });
      
      if (response.ok) {
        await fetchServices();
        await fetchStats();
        setIsEditing(false);
        setSelectedService(null);
        alert('✅ Услуга успешно обновлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('❌ Ошибка при сохранении');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setSelectedService(null);
    setEditForm({ name: '', price: '', description: '', image_url: '' });
  };

  const handleAddClick = () => {
    setAddForm({ subcategory_id: '', name: '', price: '', description: '', image_url: '' });
    setSelectedCategoryId('');
    setIsAdding(true);
  };

  const handleAddService = async () => {
    if (!addForm.subcategory_id || !addForm.name || !addForm.price) {
      alert('❌ Заполните все обязательные поля');
      return;
    }
    
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subcategory_id: parseInt(addForm.subcategory_id),
          name: addForm.name,
          price: addForm.price,
          description: addForm.description,
          image_url: addForm.image_url,
          admin_id: currentAdmin?.id || 1
        })
      });
      
      if (response.ok) {
        await fetchServices();
        await fetchStats();
        setIsAdding(false);
        setAddForm({ subcategory_id: '', name: '', price: '', description: '', image_url: '' });
        setSelectedCategoryId('');
        alert('✅ Услуга успешно добавлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления:', error);
      alert('❌ Ошибка при добавлении услуги');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelAdd = () => {
    setIsAdding(false);
    setAddForm({ subcategory_id: '', name: '', price: '', description: '', image_url: '' });
    setSelectedCategoryId('');
  };

  const handleDeleteService = async (service) => {
    if (!window.confirm(`Удалить услугу "${service.name}"?`)) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/services/${service.id}`, { method: 'DELETE' });
      if (response.ok) {
        await fetchServices();
        await fetchStats();
        alert('✅ Услуга удалена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка удаления:', error);
      alert('❌ Ошибка при удалении');
    } finally {
      setIsLoading(false);
    }
  };

  // ============= ФУНКЦИИ ДЛЯ ВРАЧЕЙ ============= (оставляем как есть)
  const handleDoctorPhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('❌ Поддерживаются только форматы: JPG, PNG, GIF, WEBP');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('❌ Размер фото не должен превышать 5MB');
      return;
    }
    setUploadingPhoto(true);
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDoctorForm({ ...doctorForm, image_url: reader.result });
        setUploadingPhoto(false);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Ошибка загрузки фото:', error);
      alert('❌ Ошибка при загрузке фото');
      setUploadingPhoto(false);
    }
  };

  const handleAddDoctor = async () => {
    if (!doctorForm.name || !doctorForm.specialization) {
      alert('❌ Заполните имя и специализацию');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(doctorForm)
      });
      if (response.ok) {
        await fetchDoctors();
        setShowAddDoctorModal(false);
        setDoctorForm({ name: '', specialization: '', description: '', image_url: '' });
        alert('✅ Врач добавлен');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления врача:', error);
      alert('❌ Ошибка при добавлении врача');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateDoctor = async () => {
    if (!editingDoctor) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctors/${editingDoctor.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(doctorForm)
      });
      if (response.ok) {
        await fetchDoctors();
        setEditingDoctor(null);
        setDoctorForm({ name: '', specialization: '', description: '', image_url: '' });
        alert('✅ Врач обновлен');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка обновления врача:', error);
      alert('❌ Ошибка при обновлении врача');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteDoctor = async (doctorId) => {
    if (!window.confirm('Удалить врача?')) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctors/${doctorId}`, { method: 'DELETE' });
      if (response.ok) {
        await fetchDoctors();
        alert('✅ Врач удален');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка удаления врача:', error);
      alert('❌ Ошибка при удалении врача');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDoctorServices = async (doctor) => {
    setSelectedDoctorServices(doctor);
    await fetchDoctorServices(doctor.id);
    setShowDoctorServicesModal(true);
  };

  const handleAddDoctorService = async () => {
    if (!doctorServiceForm.name || !doctorServiceForm.price) {
      alert('❌ Заполните название и цену');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctor-services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          doctor_id: selectedDoctorServices.id,
          name: doctorServiceForm.name,
          price: doctorServiceForm.price,
          description: doctorServiceForm.description
        })
      });
      if (response.ok) {
        await fetchDoctorServices(selectedDoctorServices.id);
        setDoctorServiceForm({ name: '', price: '', description: '' });
        alert('✅ Услуга добавлена');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления услуги:', error);
      alert('❌ Ошибка при добавлении услуги');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateDoctorService = async () => {
    if (!editingDoctorService) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctor-services/${editingDoctorService.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: doctorServiceForm.name,
          price: doctorServiceForm.price,
          description: doctorServiceForm.description
        })
      });
      if (response.ok) {
        await fetchDoctorServices(selectedDoctorServices.id);
        setEditingDoctorService(null);
        setDoctorServiceForm({ name: '', price: '', description: '' });
        alert('✅ Услуга обновлена');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка обновления услуги:', error);
      alert('❌ Ошибка при обновлении услуги');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteDoctorService = async (service) => {
    if (!window.confirm(`Удалить услугу "${service.name}"?`)) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/doctor-services/${service.id}`, { method: 'DELETE' });
      if (response.ok) {
        await fetchDoctorServices(selectedDoctorServices.id);
        alert('✅ Услуга удалена');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка удаления услуги:', error);
      alert('❌ Ошибка при удалении услуги');
    } finally {
      setIsLoading(false);
    }
  };

  // ============= ФУНКЦИИ ДЛЯ НОВОСТЕЙ =============
  const handleNewsPhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('❌ Поддерживаются только форматы: JPG, PNG, GIF, WEBP');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('❌ Размер фото не должен превышать 5MB');
      return;
    }
    setUploadingNewsPhoto(true);
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewsForm({ ...newsForm, image_url: reader.result });
        setUploadingNewsPhoto(false);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Ошибка загрузки фото:', error);
      alert('❌ Ошибка при загрузке фото');
      setUploadingNewsPhoto(false);
    }
  };

  const handleAddNews = async () => {
    if (!newsForm.title) {
      alert('❌ Заголовок новости обязателен');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/news`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newsForm)
      });
      if (response.ok) {
        await fetchNews();
        await fetchStats();
        setShowAddNewsModal(false);
        setNewsForm({ title: '', content: '', description: '', image_url: '', video_url: '', video_type: 'youtube', category: 'news', is_active: 1 });
        alert('✅ Новость добавлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления новости:', error);
      alert('❌ Ошибка при добавлении новости');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateNews = async () => {
    if (!editingNews) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/news/${editingNews.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newsForm)
      });
      if (response.ok) {
        await fetchNews();
        setEditingNews(null);
        setNewsForm({ title: '', content: '', description: '', image_url: '', video_url: '', video_type: 'youtube', category: 'news', is_active: 1 });
        alert('✅ Новость обновлена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка обновления новости:', error);
      alert('❌ Ошибка при обновлении новости');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteNews = async (newsItem) => {
    if (!window.confirm(`Удалить новость "${newsItem.title}"?`)) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/news/${newsItem.id}`, { method: 'DELETE' });
      if (response.ok) {
        await fetchNews();
        await fetchStats();
        alert('✅ Новость удалена!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка удаления новости:', error);
      alert('❌ Ошибка при удалении новости');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleNewsStatus = async (newsItem) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/news/${newsItem.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newsItem, is_active: newsItem.is_active ? 0 : 1 })
      });
      if (response.ok) {
        await fetchNews();
        alert(`✅ Новость ${newsItem.is_active ? 'скрыта' : 'опубликована'}`);
      } else {
        alert('❌ Ошибка изменения статуса');
      }
    } catch (error) {
      console.error('Ошибка изменения статуса:', error);
      alert('❌ Ошибка при изменении статуса');
    } finally {
      setIsLoading(false);
    }
  };

  // ============= IP АДРЕСА =============
  const handleAddIp = async () => {
    if (!newIp.trim()) {
      alert('❌ Введите IP адрес');
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/admin-ips`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ip_address: newIp.trim() })
      });
      if (response.ok) {
        await fetchAdminIps();
        await fetchStats();
        setShowAddIpModal(false);
        setNewIp('');
        alert('✅ IP адрес добавлен!');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка добавления IP:', error);
      alert('❌ Ошибка при добавлении IP');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteIp = async (id) => {
    if (!window.confirm('Удалить IP адрес?')) return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/admin-ips/${id}`, { method: 'DELETE' });
      if (response.ok) {
        await fetchAdminIps();
        await fetchStats();
        alert('✅ IP адрес удален');
      } else {
        const error = await response.json();
        alert(`❌ Ошибка: ${error.error}`);
      }
    } catch (error) {
      console.error('Ошибка удаления IP:', error);
      alert('❌ Ошибка при удалении IP');
    } finally {
      setIsLoading(false);
    }
  };

  // ============= ЛОГИН =============
  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: loginForm.username, password: loginForm.password })
      });
      const data = await response.json();
      if (response.ok && data.success && (data.user.role === 'admin' || data.user.role === 'manager')) {
        setIsAuthenticated(true);
        setCurrentAdmin(data.user);
        setLoginError('');
        alert(`✅ Добро пожаловать, ${data.user.username || data.user.email}!`);
      } else {
        setLoginError(data.error || 'Неверный логин или пароль');
      }
    } catch (error) {
      console.error('Ошибка входа:', error);
      setLoginError('Ошибка подключения к серверу');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-panel">
        <div className="admin-header">
          <button className="back-btn-full" onClick={onBack}>← Назад</button>
        </div>
        <div className="login-container">
          <div className="login-card">
            <div className="login-icon">⚙️</div>
            <h2>Вход в админ-панель</h2>
            <input type="text" className="login-input" placeholder="Логин" value={loginForm.username} onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })} onKeyPress={(e) => e.key === 'Enter' && handleLogin()} disabled={isLoading} />
            <input type="password" className="login-input" placeholder="Пароль" value={loginForm.password} onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })} onKeyPress={(e) => e.key === 'Enter' && handleLogin()} disabled={isLoading} />
            {loginError && <div className="login-error">{loginError}</div>}
            <button className="login-btn" onClick={handleLogin} disabled={isLoading}>{isLoading ? 'Загрузка...' : 'Войти'}</button>
            <p className="login-hint">Демо: admin / admin123</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <button className="back-btn-full" onClick={onBack}>← Назад</button>
        <div className="admin-header-right">
          <button className={`add-service-btn ${activeMainTab === 'services' ? 'active' : ''}`} onClick={() => { setActiveMainTab('services'); setSelectedCategoryId(''); setSelectedSubcategoryId(''); setSearchTerm(''); }}>📋 Управление услугами</button>
          <button className={`add-service-btn ${activeMainTab === 'doctors' ? 'active' : ''}`} onClick={() => setActiveMainTab('doctors')}>👨‍⚕️ Управление врачами</button>
          <button className={`add-service-btn ${activeMainTab === 'news' ? 'active' : ''}`} onClick={() => setActiveMainTab('news')}>📰 Инфоцентр ({news.length})</button>
          <button className="add-admin-btn" onClick={() => setShowAddIpModal(true)} disabled={isLoading}>👥 Добавить IP</button>
          <button className="logout-btn" onClick={() => setIsAuthenticated(false)}>🚪 Выйти</button>
        </div>
      </div>

      <div className="admin-content">
        <div className="admin-stats">
          <h3>📊 Статистика</h3>
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-value">{stats.total_services}</div><div className="stat-label">Всего услуг</div></div>
            <div className="stat-card"><div className="stat-value">{stats.total_categories}</div><div className="stat-label">Категорий</div></div>
            <div className="stat-card"><div className="stat-value">{stats.total_subcategories}</div><div className="stat-label">Подкатегорий</div></div>
            <div className="stat-card"><div className="stat-value">{doctors.length}</div><div className="stat-label">Врачей</div></div>
            <div className="stat-card"><div className="stat-value">{news.length}</div><div className="stat-label">Новостей</div></div>
          </div>
        </div>

        {/* ============= ВКЛАДКА УСЛУГИ ============= */}
        {activeMainTab === 'services' && (
          <>
            <div className="admin-search">
              <h3>🔍 Фильтр и поиск услуг</h3>
              
              {/* Кнопки для добавления категорий и подкатегорий */}
              <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                <button 
                  className="add-service-btn" 
                  onClick={() => setShowAddCategoryModal(true)}
                  style={{ background: 'rgba(155, 89, 182, 0.25)', borderColor: 'rgba(155, 89, 182, 0.4)', padding: '10px 16px', fontSize: '13px' }}
                >
                  📁 Добавить категорию
                </button>
                <button 
                  className="add-service-btn" 
                  onClick={() => setShowAddSubcategoryModal(true)}
                  style={{ background: 'rgba(52, 152, 219, 0.25)', borderColor: 'rgba(52, 152, 219, 0.4)', padding: '10px 16px', fontSize: '13px' }}
                >
                  📂 Добавить подкатегорию
                </button>
              </div>
              
              <div className="filter-row" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px' }}>
                <select 
                  className="edit-input" 
                  value={selectedCategoryId} 
                  onChange={(e) => {
                    setSelectedCategoryId(e.target.value);
                    setSelectedSubcategoryId('');
                  }} 
                  style={{ flex: 1 }}
                >
                  <option value="">Все категории</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
                
                {selectedCategoryId && getFilteredSubcategories().length > 0 && (
                  <select 
                    className="edit-input" 
                    value={selectedSubcategoryId} 
                    onChange={(e) => setSelectedSubcategoryId(e.target.value)} 
                    style={{ flex: 1 }}
                  >
                    <option value="">Все подкатегории</option>
                    {getFilteredSubcategories().map(sub => (
                      <option key={sub.id} value={sub.id}>{sub.name}</option>
                    ))}
                  </select>
                )}
              </div>
              
              <div className="search-container">
                <input 
                  type="text" 
                  className="search-input" 
                  placeholder="Поиск по названию или цене..." 
                  value={searchTerm} 
                  onChange={(e) => setSearchTerm(e.target.value)} 
                  disabled={isLoading} 
                />
                {searchTerm && <button className="search-clear" onClick={() => setSearchTerm('')}>✕</button>}
              </div>
            </div>

            <div className="services-list-container">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h3>📋 Список услуг ({filteredServices.length})</h3>
                <button className="add-service-btn" onClick={handleAddClick} style={{ padding: '10px 20px', width: 'auto' }}>➕ Добавить услугу</button>
              </div>
              
              {isLoading ? (
                <div className="loading-spinner">Загрузка...</div>
              ) : (
                <div className="services-table">
                  <div className="services-header-row">
                    <div>Фото</div>
                    <div>Категория</div>
                    <div>Подкатегория</div>
                    <div>Название</div>
                    <div>Цена</div>
                    <div>Действия</div>
                  </div>
                  <div className="services-rows">
                    {filteredServices.map((service) => (
                      <div key={service.id} className="service-row">
                        <div>
                          {service.image_url ? (
                            <img src={service.image_url} alt={service.name} style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ width: '50px', height: '50px', borderRadius: '8px', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>🖼️</div>
                          )}
                        </div>
                        <div>
                          <span className="category-badge">{getCategoryName(service.subcategory_id)}</span>
                        </div>
                        <div>
                          <span className="subcategory-badge" style={{ background: 'rgba(155, 89, 182, 0.25)', padding: '4px 10px', borderRadius: '12px', fontSize: '12px' }}>
                            {getSubcategoryName(service.subcategory_id)}
                          </span>
                        </div>
                        <div>
                          <div className="service-name">{service.name}</div>
                          {service.description && <div className="service-description">{service.description}</div>}
                        </div>
                        <div><span className="price-value">{service.price} ₽</span></div>
                        <div className="col-actions">
                          <button className="edit-btn" onClick={() => handleEditClick(service)}>✏️</button>
                          <button className="delete-btn" onClick={() => handleDeleteService(service)}>🗑️</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {filteredServices.length === 0 && !isLoading && (
                <div className="no-results"><p>🔍 Ничего не найдено</p></div>
              )}
            </div>
          </>
        )}

        {/* ============= ВКЛАДКА ВРАЧИ ============= */}
        {activeMainTab === 'doctors' && (
          <div className="services-list-container">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3>👨‍⚕️ Управление врачами</h3>
              <button className="add-service-btn" onClick={() => setShowAddDoctorModal(true)}>➕ Добавить врача</button>
            </div>
            <div className="services-table">
              <div className="services-header-row">
                <div>Фото</div>
                <div>ФИО</div>
                <div>Специализация</div>
                <div>Услуги</div>
                <div>Действия</div>
              </div>
              {doctors.map(doctor => (
                <div key={doctor.id} className="service-row">
                  <div>
                    {doctor.image_url ? (
                      <img src={doctor.image_url} alt={doctor.name} style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '50px', height: '50px', borderRadius: '50%', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>👨‍⚕️</div>
                    )}
                  </div>
                  <div>{doctor.name}</div>
                  <div><span className="category-badge">{doctor.specialization}</span></div>
                  <div>
                    <button className="edit-btn" onClick={() => handleOpenDoctorServices(doctor)} style={{ background: 'rgba(39, 174, 96, 0.25)' }}>📋 Управление услугами</button>
                  </div>
                  <div className="col-actions">
                    <button className="edit-btn" onClick={() => { setEditingDoctor(doctor); setDoctorForm({ name: doctor.name, specialization: doctor.specialization, description: doctor.description || '', image_url: doctor.image_url || '' }); }}>✏️</button>
                    <button className="delete-btn" onClick={() => handleDeleteDoctor(doctor.id)}>🗑️</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ============= ВКЛАДКА НОВОСТИ ============= */}
        {activeMainTab === 'news' && (
          <div className="services-list-container">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3>📰 Управление новостями</h3>
              <button className="add-service-btn" onClick={() => { setEditingNews(null); setNewsForm({ title: '', content: '', description: '', image_url: '', video_url: '', video_type: 'youtube', category: 'news', is_active: 1 }); setShowAddNewsModal(true); }}>➕ Добавить новость</button>
            </div>
            
            <div className="admin-search">
              <div className="search-container">
                <input type="text" className="search-input" placeholder="Поиск новостей..." value={newsSearchTerm} onChange={(e) => setNewsSearchTerm(e.target.value)} />
                {newsSearchTerm && <button className="search-clear" onClick={() => setNewsSearchTerm('')}>✕</button>}
              </div>
            </div>
            
            <div className="services-table">
              <div className="services-header-row">
                <div>Фото</div>
                <div>Заголовок</div>
                <div>Категория</div>
                <div>Статус</div>
                <div>Действия</div>
              </div>
              {filteredNews.map((item) => (
                <div key={item.id} className="service-row">
                  <div>
                    {item.image_url ? (
                      <img src={item.image_url} alt={item.title} style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '50px', height: '50px', borderRadius: '8px', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>📰</div>
                    )}
                  </div>
                  <div>
                    <strong>{item.title}</strong><br/>
                    <small style={{ color: 'rgba(255,255,255,0.5)' }}>{new Date(item.created_at).toLocaleDateString('ru-RU')}</small>
                  </div>
                  <div>
                    <span className="category-badge" style={{ 
                      background: item.category === 'video' ? 'rgba(155, 89, 182, 0.25)' : item.category === 'promo' ? 'rgba(243, 156, 18, 0.25)' : 'rgba(52, 152, 219, 0.25)' 
                    }}>
                      {item.category === 'video' ? '🎬 Видео' : item.category === 'promo' ? '🎁 Акция' : '📰 Новость'}
                    </span>
                  </div>
                  <div>
                    <span style={{ 
                      background: item.is_active ? 'rgba(46, 204, 113, 0.2)' : 'rgba(149, 165, 166, 0.2)', 
                      color: item.is_active ? '#2ecc71' : '#95a5a6', 
                      padding: '4px 12px', 
                      borderRadius: '20px', 
                      fontSize: '12px' 
                    }}>
                      {item.is_active ? 'Активна' : 'Скрыта'}
                    </span>
                  </div>
                  <div className="col-actions">
                    <button className="edit-btn" onClick={() => { setEditingNews(item); setNewsForm({ title: item.title, content: item.content || '', description: item.description || '', image_url: item.image_url || '', video_url: item.video_url || '', video_type: item.video_type || 'youtube', category: item.category || 'news', is_active: item.is_active }); setShowAddNewsModal(true); }}>✏️</button>
                    <button className="edit-btn" onClick={() => toggleNewsStatus(item)} style={{ background: item.is_active ? 'rgba(243, 156, 18, 0.25)' : 'rgba(46, 204, 113, 0.25)' }}>{item.is_active ? '🔒 Скрыть' : '🔓 Опубликовать'}</button>
                    <button className="delete-btn" onClick={() => handleDeleteNews(item)}>🗑️</button>
                  </div>
                </div>
              ))}
            </div>
            {filteredNews.length === 0 && !isLoading && <div className="no-results"><p>🔍 Новостей не найдено</p></div>}
          </div>
        )}

        {/* ============= IP АДРЕСА ============= */}
        <div className="admins-list" style={{ marginTop: '30px' }}>
          <h3>👑 IP адреса для отображения админ-панели</h3>
          <div className="services-table">
            <div className="services-header-row">
              <div>IP адрес</div>
              <div>Действия</div>
            </div>
            {allowedIps.map((ip) => (
              <div key={ip.id} className="service-row">
                <div className="col-ip">{ip.ip_address}</div>
                <div className="col-actions">
                  <button className="delete-admin-btn" onClick={() => handleDeleteIp(ip.id)} disabled={isLoading}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ============= МОДАЛЬНЫЕ ОКНА ============= */}
      
      {/* Модалка добавления категории */}
      {showAddCategoryModal && (
        <div className="modal-overlay" onClick={() => setShowAddCategoryModal(false)}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📁 Добавление новой категории</h3>
              <button className="modal-close" onClick={() => setShowAddCategoryModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Название категории *</label>
                <input
                  type="text"
                  className="edit-input"
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  placeholder="Например: Новая категория"
                  autoFocus
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => setShowAddCategoryModal(false)}>Отмена</button>
              <button className="save-edit-btn" onClick={handleAddCategory} disabled={isLoading || !newCategoryName.trim()}>
                {isLoading ? 'Добавление...' : '➕ Добавить категорию'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка добавления подкатегории */}
      {showAddSubcategoryModal && (
        <div className="modal-overlay" onClick={() => setShowAddSubcategoryModal(false)}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📂 Добавление новой подкатегории</h3>
              <button className="modal-close" onClick={() => setShowAddSubcategoryModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Родительская категория *</label>
                <select
                  className="edit-input"
                  value={selectedParentCategoryId}
                  onChange={(e) => setSelectedParentCategoryId(e.target.value)}
                >
                  <option value="">Выберите категорию</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Название подкатегории *</label>
                <input
                  type="text"
                  className="edit-input"
                  value={newSubcategoryName}
                  onChange={(e) => setNewSubcategoryName(e.target.value)}
                  placeholder="Например: Новая подкатегория"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => setShowAddSubcategoryModal(false)}>Отмена</button>
              <button className="save-edit-btn" onClick={handleAddSubcategory} disabled={isLoading || !selectedParentCategoryId || !newSubcategoryName.trim()}>
                {isLoading ? 'Добавление...' : '➕ Добавить подкатегорию'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка добавления услуги */}
      {isAdding && (
        <div className="modal-overlay" onClick={handleCancelAdd}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>➕ Добавление новой услуги</h3>
              <button className="modal-close" onClick={handleCancelAdd}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Категория *</label>
                <select 
                  value={selectedCategoryId} 
                  onChange={(e) => {
                    const newCategoryId = e.target.value;
                    setSelectedCategoryId(newCategoryId);
                    setAddForm({ ...addForm, subcategory_id: '' });
                  }} 
                  className="edit-input"
                >
                  <option value="">Выберите категорию</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
              
              {selectedCategoryId && (
                <div className="form-group">
                  <label>Подкатегория *</label>
                  <select 
                    value={addForm.subcategory_id} 
                    onChange={(e) => setAddForm({ ...addForm, subcategory_id: e.target.value })} 
                    className="edit-input"
                  >
                    <option value="">Выберите подкатегорию</option>
                    {getFilteredSubcategories().map(sub => (
                      <option key={sub.id} value={sub.id}>{sub.name}</option>
                    ))}
                  </select>
                  {getFilteredSubcategories().length === 0 && (
                    <p style={{ color: '#e74c3c', marginTop: '5px', fontSize: '12px' }}>Нет подкатегорий для выбранной категории</p>
                  )}
                </div>
              )}
              
              <div className="form-group">
                <label>Фото услуги</label>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <div>
                    {addForm.image_url ? (
                      <img src={addForm.image_url} alt="Фото" style={{ width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '80px', height: '80px', borderRadius: '8px', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '30px' }}>🖼️</div>
                    )}
                  </div>
                  <div>
                    <input type="file" ref={serviceFileInputRef} accept="image/*" onChange={(e) => handleServicePhotoUpload(e, false)} style={{ display: 'none' }} />
                    <button type="button" className="edit-btn" onClick={() => serviceFileInputRef.current?.click()} disabled={uploadingPhoto}>
                      {uploadingPhoto ? '⏳ Загрузка...' : '📷 Выбрать фото'}
                    </button>
                    {addForm.image_url && (
                      <button type="button" className="delete-btn" onClick={() => handleRemoveServicePhoto(false)}>🗑️ Удалить</button>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="form-group">
                <label>Название *</label>
                <input type="text" value={addForm.name} onChange={(e) => setAddForm({ ...addForm, name: e.target.value })} className="edit-input" placeholder="Введите название" />
              </div>
              
              <div className="form-group">
                <label>Цена (₽) *</label>
                <input type="text" value={addForm.price} onChange={(e) => setAddForm({ ...addForm, price: e.target.value })} className="edit-input" placeholder="Введите цену" />
              </div>
              
              <div className="form-group">
                <label>Описание</label>
                <textarea value={addForm.description} onChange={(e) => setAddForm({ ...addForm, description: e.target.value })} className="edit-textarea" rows="3" placeholder="Описание (необязательно)" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={handleCancelAdd}>Отмена</button>
              <button className="save-edit-btn" onClick={handleAddService} disabled={isLoading || !addForm.subcategory_id}>
                {isLoading ? 'Добавление...' : '➕ Добавить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка редактирования услуги */}
      {isEditing && (
        <div className="modal-overlay" onClick={handleCancelEdit}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>✏️ Редактирование услуги</h3>
              <button className="modal-close" onClick={handleCancelEdit}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Фото услуги</label>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <div>
                    {editForm.image_url ? (
                      <img src={editForm.image_url} alt="Фото" style={{ width: '80px', height: '80px', borderRadius: '8px', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '80px', height: '80px', borderRadius: '8px', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '30px' }}>🖼️</div>
                    )}
                  </div>
                  <div>
                    <input type="file" ref={serviceFileInputRef} accept="image/*" onChange={(e) => handleServicePhotoUpload(e, true)} style={{ display: 'none' }} />
                    <button type="button" className="edit-btn" onClick={() => serviceFileInputRef.current?.click()} disabled={uploadingPhoto}>
                      {uploadingPhoto ? '⏳ Загрузка...' : '📷 Выбрать фото'}
                    </button>
                    {editForm.image_url && (
                      <button type="button" className="delete-btn" onClick={() => handleRemoveServicePhoto(true)}>🗑️ Удалить</button>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="form-group">
                <label>Название</label>
                <input type="text" value={editForm.name} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Цена (₽)</label>
                <input type="text" value={editForm.price} onChange={(e) => setEditForm({ ...editForm, price: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Описание</label>
                <textarea value={editForm.description} onChange={(e) => setEditForm({ ...editForm, description: e.target.value })} className="edit-textarea" rows="3" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={handleCancelEdit}>Отмена</button>
              <button className="save-edit-btn" onClick={handleSaveChanges} disabled={isLoading}>
                {isLoading ? 'Сохранение...' : '💾 Сохранить'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка добавления/редактирования врача */}
      {(showAddDoctorModal || editingDoctor) && (
        <div className="modal-overlay" onClick={() => { setShowAddDoctorModal(false); setEditingDoctor(null); }}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingDoctor ? '✏️ Редактирование врача' : '➕ Добавление врача'}</h3>
              <button className="modal-close" onClick={() => { setShowAddDoctorModal(false); setEditingDoctor(null); }}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Фото врача</label>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <div>
                    {doctorForm.image_url ? (
                      <img src={doctorForm.image_url} alt="Фото" style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '30px' }}>👨‍⚕️</div>
                    )}
                  </div>
                  <div>
                    <input type="file" ref={fileInputRef} accept="image/*" onChange={handleDoctorPhotoUpload} style={{ display: 'none' }} />
                    <button type="button" className="edit-btn" onClick={() => fileInputRef.current?.click()} disabled={uploadingPhoto}>
                      {uploadingPhoto ? '⏳ Загрузка...' : '📷 Выбрать фото'}
                    </button>
                    {doctorForm.image_url && (
                      <button type="button" className="delete-btn" onClick={() => setDoctorForm({ ...doctorForm, image_url: '' })}>🗑️ Удалить</button>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="form-group">
                <label>ФИО врача *</label>
                <input type="text" value={doctorForm.name} onChange={(e) => setDoctorForm({ ...doctorForm, name: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Специализация *</label>
                <input type="text" value={doctorForm.specialization} onChange={(e) => setDoctorForm({ ...doctorForm, specialization: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Описание</label>
                <textarea value={doctorForm.description} onChange={(e) => setDoctorForm({ ...doctorForm, description: e.target.value })} className="edit-textarea" rows="3" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => { setShowAddDoctorModal(false); setEditingDoctor(null); }}>Отмена</button>
              <button className="save-edit-btn" onClick={editingDoctor ? handleUpdateDoctor : handleAddDoctor} disabled={isLoading}>
                {isLoading ? 'Сохранение...' : (editingDoctor ? '💾 Сохранить' : '➕ Добавить')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка управления услугами врача */}
      {showDoctorServicesModal && selectedDoctorServices && (
        <div className="modal-overlay" onClick={() => setShowDoctorServicesModal(false)}>
          <div className="edit-modal" style={{ maxWidth: '700px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📋 Услуги врача: {selectedDoctorServices.name}</h3>
              <button className="modal-close" onClick={() => setShowDoctorServicesModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255,255,255,0.05)', borderRadius: '16px' }}>
                <h4>➕ Добавить услугу</h4>
                <div className="form-group">
                  <label>Название</label>
                  <input type="text" value={doctorServiceForm.name} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, name: e.target.value })} className="edit-input" />
                </div>
                <div className="form-group">
                  <label>Цена (₽)</label>
                  <input type="text" value={doctorServiceForm.price} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, price: e.target.value })} className="edit-input" />
                </div>
                <div className="form-group">
                  <label>Описание</label>
                  <textarea value={doctorServiceForm.description} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, description: e.target.value })} className="edit-textarea" rows="2" />
                </div>
                <button className="save-edit-btn" onClick={handleAddDoctorService} disabled={isLoading} style={{ width: '100%' }}>➕ Добавить услугу</button>
              </div>
              
              <h4>📋 Список услуг</h4>
              <div className="services-table">
                <div className="services-header-row">
                  <div>Название</div>
                  <div>Цена</div>
                  <div>Действия</div>
                </div>
                {doctorServices.map(service => (
                  <div key={service.id} className="service-row">
                    <div>{service.name}</div>
                    <div>{service.price} ₽</div>
                    <div className="col-actions">
                      <button className="edit-btn" onClick={() => { setEditingDoctorService(service); setDoctorServiceForm({ name: service.name, price: service.price, description: service.description || '' }); }}>✏️</button>
                      <button className="delete-btn" onClick={() => handleDeleteDoctorService(service)}>🗑️</button>
                    </div>
                  </div>
                ))}
                {doctorServices.length === 0 && <div className="no-results">Нет услуг для этого врача</div>}
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => setShowDoctorServicesModal(false)}>Закрыть</button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка редактирования услуги врача */}
      {editingDoctorService && (
        <div className="modal-overlay" onClick={() => { setEditingDoctorService(null); setDoctorServiceForm({ name: '', price: '', description: '' }); }}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>✏️ Редактирование услуги врача</h3>
              <button className="modal-close" onClick={() => { setEditingDoctorService(null); setDoctorServiceForm({ name: '', price: '', description: '' }); }}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Название</label>
                <input type="text" value={doctorServiceForm.name} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, name: e.target.value })} className="edit-input" />
              </div>
              <div className="form-group">
                <label>Цена (₽)</label>
                <input type="text" value={doctorServiceForm.price} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, price: e.target.value })} className="edit-input" />
              </div>
              <div className="form-group">
                <label>Описание</label>
                <textarea value={doctorServiceForm.description} onChange={(e) => setDoctorServiceForm({ ...doctorServiceForm, description: e.target.value })} className="edit-textarea" rows="3" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => { setEditingDoctorService(null); setDoctorServiceForm({ name: '', price: '', description: '' }); }}>Отмена</button>
              <button className="save-edit-btn" onClick={handleUpdateDoctorService} disabled={isLoading}>💾 Сохранить</button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка новостей */}
      {showAddNewsModal && (
        <div className="modal-overlay" onClick={() => { setShowAddNewsModal(false); setEditingNews(null); }}>
          <div className="edit-modal" style={{ maxWidth: '700px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingNews ? '✏️ Редактирование новости' : '➕ Добавление новости'}</h3>
              <button className="modal-close" onClick={() => { setShowAddNewsModal(false); setEditingNews(null); }}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Фото/Превью</label>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <div>
                    {newsForm.image_url ? (
                      <img src={newsForm.image_url} alt="Превью" style={{ width: '80px', height: '60px', borderRadius: '8px', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '80px', height: '60px', borderRadius: '8px', background: '#3498db', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>📷</div>
                    )}
                  </div>
                  <div>
                    <input type="file" ref={newsFileInputRef} accept="image/*" onChange={handleNewsPhotoUpload} style={{ display: 'none' }} />
                    <button type="button" className="edit-btn" onClick={() => newsFileInputRef.current?.click()} disabled={uploadingNewsPhoto}>
                      {uploadingNewsPhoto ? '⏳ Загрузка...' : '📷 Выбрать фото'}
                    </button>
                    {newsForm.image_url && (
                      <button type="button" className="delete-btn" onClick={() => setNewsForm({ ...newsForm, image_url: '' })}>🗑️ Удалить</button>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="form-group">
                <label>Заголовок *</label>
                <input type="text" value={newsForm.title} onChange={(e) => setNewsForm({ ...newsForm, title: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Краткое описание</label>
                <input type="text" value={newsForm.description} onChange={(e) => setNewsForm({ ...newsForm, description: e.target.value })} className="edit-input" />
              </div>
              
              <div className="form-group">
                <label>Полный текст</label>
                <textarea value={newsForm.content} onChange={(e) => setNewsForm({ ...newsForm, content: e.target.value })} className="edit-textarea" rows="5" />
              </div>
              
              <div className="form-group">
                <label>Ссылка на видео</label>
                <input type="text" value={newsForm.video_url} onChange={(e) => setNewsForm({ ...newsForm, video_url: e.target.value })} className="edit-input" placeholder="https://www.youtube.com/watch?v=..." />
              </div>
              
              <div className="form-group">
                <label>Категория</label>
                <select value={newsForm.category} onChange={(e) => setNewsForm({ ...newsForm, category: e.target.value })} className="edit-input">
                  <option value="news">📰 Новости</option>
                  <option value="video">🎬 Видео</option>
                  <option value="promo">🎁 Акции</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Статус</label>
                <select value={newsForm.is_active} onChange={(e) => setNewsForm({ ...newsForm, is_active: parseInt(e.target.value) })} className="edit-input">
                  <option value="1">Опубликована</option>
                  <option value="0">Скрыта</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => { setShowAddNewsModal(false); setEditingNews(null); }}>Отмена</button>
              <button className="save-edit-btn" onClick={editingNews ? handleUpdateNews : handleAddNews} disabled={isLoading || !newsForm.title}>
                {isLoading ? 'Сохранение...' : (editingNews ? '💾 Сохранить' : '➕ Добавить')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модалка IP */}
      {showAddIpModal && (
        <div className="modal-overlay" onClick={() => setShowAddIpModal(false)}>
          <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>👥 Добавить IP адрес</h3>
              <button className="modal-close" onClick={() => setShowAddIpModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>IP адрес</label>
                <input type="text" value={newIp} onChange={(e) => setNewIp(e.target.value)} className="edit-input" placeholder="192.168.1.1" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-edit-btn" onClick={() => setShowAddIpModal(false)}>Отмена</button>
              <button className="save-edit-btn" onClick={handleAddIp} disabled={isLoading}>➕ Добавить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;